import { useStore } from "@/store";
const store = useStore();
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import moment from "moment";
import { Roles } from "../enums/Roles";

const company = store.getters.company;
let path = `company/${company.companyGuid}/sites`;
const user = store.getters.loggedInUser;
const site = store.getters.site;
const group = store.getters.group;
if(user.role === Roles.AGMSAdmin) {
  path = `company/`
}else if(user.role === Roles.PartnerAdmin) {
  path = `company/`
}else if(user.role === Roles.CompanyAdmin) {
  path = `company/${company.companyGuid}/sites`
}else if(user.role === Roles.SiteAdmin) {
  path = `company/${company.companyGuid}/sites/${site.key}/groups`
}else if(user.role === Roles.GroupAdmin) {
  path = `company/${company.companyGuid}/sites/${site.key}/groups/${group.key}/computers`
}

const companyGuid = location.pathname.split('/')[3];
const siteGuid = location.pathname.split('/')[5];

const data = {
  readyToUseFilters: {},
  filter: {
    ignoreSaveFilter: true,
    title: "newcomfilter",
    redirect: "/endpoints/computers/all?filterStatus=true",
    pageName: "AssetPageFilter",
    genre: "assetPageFilter",
    filters: [
      {
        title: "siteandgroup",
        type: "wordstyped",
        param: "siteandgroup",
      },
    ],
  },
  header: {
    navigation: [
      {
        title: "endpoints",
        icon: "drak_computer",
        url: "computers/all",
      },
      {
        title: "browseassets",
        active: true,
        icon: "breadcrumb",
        url: path,
      },
      {
        title: "usersbycomputer",
        icon: "group",
        url: "users-by-computers",
      },
    ],
    buttonPosition: "pr-4 justify-content-between",
    buttons: [],
  },
  component: {
    type: "ag-table",
    options: {
      columns: [
        {
          label: "endpointHostName",
          field: "WindowsComputerName",
          width: "180px",
          sortable: true,
          components: [
            {
              component: "rowRouter",
              key: "WindowsComputerName",
              route: function (row: any) {
                if(row && row.isDeleted) {
                  return '#';
                }
                const companyGuid = location.pathname.split('/')[3];
                const siteGuid = location.pathname.split('/')[5];
                const url = `/endpoints/company/${companyGuid}/sites/${siteGuid}/groups/${row.GroupGuid}/computers/${row.ComputerId}`;
                return url;
              },
              truncate: {
                position: "middle",
                first: 6,
                last: 6,
              },
              displayField: "WindowsComputerName",
            },
          ],
        },
        // {
        //   label: "computername",
        //   field: "windowsComputerName",
        //   excelField: "WindowsComputerName",
        //   width: "200px",
        //   sortable: false,
        //   display: function (row) {
        //     const companyGuid = companyGuid;
        //     const siteGuid = row.companySiteGroupInfo.siteGuid;
        //     const groupGuid = row.companySiteGroupInfo.groupGuid;
        //     return `<a href="}" class="is-rows-el name-btn">${row.WindowsComputerName}</a>`;
        //   },
        // },
        {
          label: "lastreported",
          sortable: true,
          excelField: "updateAt",
          field: "updateAt",
          components: [
            {
              component: "tableDateFormatter",
              field: "updateAt",
            },
          ],
        },
        {
          label: "lastipv4v6",
          sortable: false,
          display: function (row: any) {
            return `<div class="d-flex align-items-start flex-column"><span> ${row.LastIPv4}</span> <span> ${row.LastIPv6}</span></div>`
          },
        },
        {
          label: "operationsys",
          field: "hostOperatingSystemName",
          excelField: "hostOperatingSystemName",
          sortable: false,
        },
        {
          label: "agentversion",
          field: "AgentVersion",
          excelField: "AgentVersion",
          sortable: false,
        },
        {
          label: "policyversion",
          field: "PolicyFileVersion",
          excelField: "PolicyFileVersion",
          sortable: false,
        },
        {
          label: "eventcount",
          field: "eventCount",
          format: 'number',
          excelField: "eventCount",
          sortable: false,
        },
        {
          label: "malicioushashes",
          field: "maliciousHashCount",
          format: 'number',
          excelField: "maliciousHashCount",
          sortable: false,
        },
        {
          label: "protectionStatus",
          field: "LastProtectionStatus",
          excelField: "LastProtectionStatus",
          sortable: false,
        },
        {
          label: "",
          field: "edit",
          width: '100px',
          components: [
            {
              component: "tableOtpComponent",
              class: "mr-2 ml-2",
            },
          ],
        },
        {
          label: "",
          field: "edit",
          width: '100px',
          components: [
            {
              component: "tableDeleteComponent",
              class: "mr-2 ml-2",
              idField: "ComputerId",
              checkDelete: "isDeleted"
            },
          ],
        },
      ],
      rows: [],
      total: 0,
      sortable: {
        order: "firstName",
        sort: "asc",
      },
      page: 1,
      pageSize: 10,
      isLoading: true,
      dateFilter: false,
      hasShowDeleted: true,
      fetchTable: async (options: any) => {
        const filters = data.readyToUseFilters;
        const body = { filters, options };
        store.dispatch(GeneralActionTypes.GET_ASSET_COMPUTERS, body);
      },
    },
  },
};

export default data;
